@if (isDataLoading) {
    @if (isWidgetLoader) {
        <span id="delay-spinner" class="delay-spinner">
            <div class="progressbar" role="progressbar">
                @for (option of options; track option) {
                    <div [ngStyle]="{'animation': option.animation}">
                        <div [style.transform]="option.transform"></div>
                    </div>  
                }
            </div>
        </span>
    } @else {
        <div class="loader-parent-in-left-nav">
            <div class="spinner loader">
                <div class="blue-spinner"></div>
                <div class="gray-spinner"></div>
            </div>
        </div>
    }
}
